import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClinical = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.999 3a.938.938 0 0 1 .893.651L17 16.488l1.608-5.023a.937.937 0 0 1 .892-.652h1.563a.938.938 0 0 1 0 1.874h-.88l-2.29 7.162a.938.938 0 0 1-1.785 0L12.006 7.032l-2.862 9.063a.938.938 0 0 1-1.775.038l-1.58-4.345-.088.26a.938.938 0 0 1-.888.64H2.938a.937.937 0 1 1 0-1.874h1.2l.722-2.171a.938.938 0 0 1 1.771-.026L8.187 12.9l2.92-9.243A.938.938 0 0 1 11.998 3Z",
		fill: "currentColor"
	})
});
export default SvgClinical;
